import { create } from "zustand";
import { DrawerType, IClean } from "./types";
import { API } from "../api";

interface IState {
  loading: boolean;
  progressPercent: number;
  progressText: string;
  error: string;
  cleans: IClean[];
  settings: any;
  done_cleans: IClean[];
  clean: IClean | null;
  drawer: DrawerType | null;
  theory: string | null;
  setDrawer: (name: DrawerType, cur?: IClean) => void;
  closeDrawer: () => void;
  cancelDrawer: () => void;
  getTheory: () => void;
  getCleans: () => void;
  getDoneCleans: () => void;
  changeClean: (dto: any) => Promise<void>;
  finishClean: (dto: any) => Promise<void>;
  uploadFinishCleanFiles: (dto: any) => Promise<any>;
  getSettings: () => void;
  setProgress: (value: number) => void;
  setProgressText: (value: string) => void;
  reloadCleans: () => Promise<void>;
}

export const useStore = create<IState>((set, get) => ({
  cleans: [],
  done_cleans: [],
  error: "",
  settings: {},
  drawer: null,
  clean: null,
  theory: null,
  loading: false,
  progressPercent: 0,
  progressText: "",
  setDrawer: (name, cur) => {
    if (cur) {
      set({ drawer: name, clean: cur, error: "" });
    } else {
      set({ drawer: name, error: "" });
    }
  },
  closeDrawer: () => set({ drawer: null }),
  changeClean: async (variables: any) => {
    const { clean, cleans } = get();
    if (clean) {
      const newCleans = cleans.map((item) => (item.id === clean?.id ? { ...item, ...variables } : item));
      try {
        await API.changeStatusOfClean({ ...variables, id: clean?.id });
        set({ clean: { ...clean, ...variables }, cleans: newCleans });
      } catch (error: any) {
        set({ error: error?.response?.data?.message });
      }
    }
  },
  finishClean: async (dto: any) => {
    set({ loading: true });
    const { clean, cleans } = get();
    if (clean) {
      await API.finishClean(dto);
      const settings = get().settings;
      let newStatus: string;
      let nextDrawer: DrawerType | null;

      if (settings?.nophoto) {
        newStatus = 'finish'
        nextDrawer = null
      } else {
        newStatus = 'finish_without_photo'
        nextDrawer = 'upload'
      }

      const newCleans = cleans.map((item) => (item.id === clean?.id ? { ...item, status: newStatus } : item));
      set({ cleans: newCleans, drawer: nextDrawer, loading: false });
    }
  },
  uploadFinishCleanFiles: async (dto: any) => {
    set({ loading: true });
    const { clean, cleans } = get();
    if (clean) {
      await API.uploadFinishClean(dto, get().setProgress);

      const newCleans = cleans.map((item) => (item.id === clean?.id ? { ...item, status: 'finish' } : item));
      set({ cleans: newCleans, drawer: null, loading: false });
    }
  },
  getCleans: async () => {
    const cleans = await API.getCleans();
    set({ cleans });
  },
  getSettings: async () => {
    const settings = await API.getSettings();
    set({ settings });
  },
  getDoneCleans: async () => {
    const done_cleans = await API.getDoneCleans();
    set({ done_cleans });
  },
  getTheory: async () => {
    const result = await API.getTheory();
    set({ theory: result.text });
  },
  cancelDrawer: () => set({ drawer: "clean" }),
  setProgress: (value: number) => set({ progressPercent: value }),
  setProgressText: (value: string) => set({ progressText: value }),
  reloadCleans: async () => {
    const { clean, getCleans } = get();
    await getCleans();
    if (clean) {
      const { cleans } = get();
      set({ clean: cleans.find((item) => item.id === clean.id) });
    }
  },
}));
